import { PaymentApprovalListObj } from "./orderManagement"

export const APPROVAL_STATUS_FILTER_SUCCESS = "APPROVAL_STATUS_FILTER_SUCCESS"
export const APPROVAL_STATUS_FILTER = "APPROVAL_STATUS_FILTER"

export const APPROVAL_LIST_SUCCESS = "APPROVAL_LIST_SUCCESS"
export const APPROVAL_LIST = "APPROVAL_LIST"

export const CHECKER_ORDER_APPROVAL_SUCCESS = "CHECKER_ORDER_APPROVAL_SUCCESS"
export const CHECKER_ORDER_APPROVAL = "CHECKER_ORDER_APPROVAL"

export const CHECKER_ORDER_DETAILS_SUCCESS = "CHECKER_ORDER_DETAILS_SUCCESS"
export const CHECKER_ORDER_DETAILS = "CHECKER_ORDER_DETAILS"

export const CHECKER_DETAILS_SUCCESS = "CHECKER_DETAILS_SUCCESS"
export const CHECKER_DETAILS = "CHECKER_DETAILS"

export const PAYMENT_APPROVAL_LIST_SUCCESS = "PAYMENT_APPROVAL_LIST_SUCCESS"
export const PAYMENT_APPROVAL_LIST = "PAYMENT_APPROVAL_LIST"

export const SETTLEMENT_APPROVAL_LIST_SUCCESS = "SETTLEMENT_APPROVAL_LIST_SUCCESS"
export const SETTLEMENT_APPROVAL_LIST = "SETTLEMENT_APPROVAL_LIST"

export const PAYMENT_DETAILS_SUCCESS = "PAYMENT_DETAILS_SUCCESS"
export const PAYMENT_DETAILS = "PAYMENT_DETAILS"

export const CHECKER_PAYMENT_APPROVAL_SUCCESS = "CHECKER_PAYMENT_APPROVAL_SUCCESS"
export const CHECKER_PAYMENT_APPROVAL = "CHECKER_PAYMENT_APPROVAL"

export const CHECKER_SETTLEMENT_APPROVAL_SUCCESS = "CHECKER_SETTLEMENT_APPROVAL_SUCCESS"
export const CHECKER_SETTLEMENT_APPROVAL = "CHECKER_SETTLEMENT_APPROVAL"

export const CHECKER_OFFLINE_PAYMENT_APPROVAL_SUCCESS = "CHECKER_OFFLINE_PAYMENT_APPROVAL_SUCCESS"
export const CHECKER_OFFLINE_PAYMENT_APPROVAL = "CHECKER_OFFLINE_PAYMENT_APPROVAL"

export const ORDER_APPROVAL_EXCEL_REPORT_SUCCESS = "ORDER_APPROVAL_EXCEL_REPORT_SUCCESS"
export const ORDER_APPROVAL_EXCEL_REPORT = "ORDER_APPROVAL_EXCEL_REPORT"

export const PAYMENT_APPROVAL_EXCEL_REPORT_SUCCESS = "PAYMENT_APPROVAL_EXCEL_REPORT_SUCCESS"
export const PAYMENT_APPROVAL_EXCEL_REPORT = "PAYMENT_APPROVAL_EXCEL_REPORT"

export const SETTLEMENT_APPROVAL_EXCEL_REPORT_SUCCESS = "SETTLEMENT_APPROVAL_EXCEL_REPORT_SUCCESS"
export const SETTLEMENT_APPROVAL_EXCEL_REPORT = "SETTLEMENT_APPROVAL_EXCEL_REPORT"

export interface ApprovalStatuFilter {
    orderStatusId: string
    orderStatusValue: string
    checked?: boolean
}

export interface OrderApprovalListReq {
    sort: string;
    order: string;
    productType: Array<string>;
    approvalStatus: Array<string>;
    searchInput: string;
    currentPage: number;
    rowsPerPage: number;
}

export interface CheckerOrderApprovalReq {
    productOrderId: string;
    product: string;
    orderId: string;
    isApproved: boolean;
    approverId: string | null;
    remarks: string
    cartId?: string | number;
}

export interface CheckerOrderApprovalRes {
    isSuccess: boolean;
    message: string
}

export interface CheckerOrderDetailsReq {
    productOrderId: string;
    product: string;
    id?: string
    cartId?: string | number;
    orderStatus?: string;
    paymentStatus?: string
    orderId?: string | number;
    locationFrom?: string;
}

export interface CheckerOrderDetailsRes {
    [key: string]: any
}

export interface PaymentApprovalListReq {
    sort: string;
    order: string;
    productType: Array<string>;
    paymentStatus: Array<string>;
    searchInput: string;
    currentPage: number;
    rowsPerPage: number;
}

export interface PaymentApprovalListRes {
    orders: Array<PaymentApprovalListObj>;
    totalCount: number;
}

// Settlement approval list shares the same request/response shape as the payment approval list
export type SettlementApprovalListReq = PaymentApprovalListReq;

export type SettlementApprovalListRes = PaymentApprovalListRes;

export interface PaymentsApprovalReq {
    productOrderId: string;
    product: string;
    orderId: string;
    isApproved: boolean;
    paymentCheckerId: string | null;
    remarks: string;
    cartId?: string | number;
}

export interface SettlementApprovalReq {
    productOrderId: string;
    product: string;
    orderId: string | number;
    isApproved: boolean;
    settlementCheckerId: string | null;
    stockSettlementReferenceNo: string;
    remarks: string;
    cartId?: string | number;
}

export interface OfflinePaymentApprovalReq {
    orderId: string;
    productOrderId: string;
    paymentCheckerId: string | null;
    product: string;
    isApproved: boolean;
    remarks: string;
    cartId?: string | number;
}

export interface OfflinePaymentApprovalRes {
    isSuccess: boolean;
    message: string;
}

export interface OrderApprovalExcelReportReq {
    productType: string[];
    approvalStatus?: string[];
    investorType?: string[];
    modeOfHolding?: string[];
    searchInput: string;
    sort: string;
    order: string;
    currentPage: number;
    rowsPerPage: number;
}

export interface PaymentApprovalExcelReportReq {
    productType: string[];
    paymentStatus: string[];
    investorType?: string[];
    modeOfHolding?: string[];
    searchInput: string;
    sort: string;
    order: string;
    currentPage: number;
    rowsPerPage: number;
}

// Settlement export shares same shape as payment export
export type SettlementApprovalExcelReportReq = PaymentApprovalExcelReportReq;
